import { Managment } from '@payu/paymentsos-types'

import config from '../envConfig'
import UsersApi from './UsersApi'
import ApiBase from './ApiBase'

class RolesApi extends ApiBase {
  fetchRoles = async (isMasquerading: boolean): Promise<Managment.Roles> => {
    const headers = this.defaultConfig
    headers.Host = config.apiUrl

    // eslint-disable-next-line camelcase
    const { account_roles } = await UsersApi.fetchUser({ expand: 'roles' }, isMasquerading)
    // eslint-disable-next-line camelcase
    return account_roles
  }
}

export default new RolesApi()
